import React from "react";
import {
  CalendarDays,
  Calendar,
  CircleDollarSign,
  ClipboardCheck,
  House,
  LogOut,
  Settings,
  Users,
} from "lucide-react";

/**
 * The main-navigation icon set, shared by the desktop sidebar (LeftMenu) and
 * the mobile drawer (MobileMenu) so both always show the same icon per concept.
 * All nav icons are thin outline lucide glyphs (NAV_STROKE_WIDTH) inheriting
 * currentColor, so `.menu-link` text colors drive rest/hover/active states.
 */

/** Shared stroke width for every navigation icon — keep them uniformly thin. */
export const NAV_STROKE_WIDTH = 1.5;

const navIconProps = { size: 24, strokeWidth: NAV_STROKE_WIDTH } as const;

export const HomeNavIcon: React.FC = () => <House {...navIconProps} />;

export const CalendarNavIcon: React.FC = () => <Calendar {...navIconProps} />;

export const AttendanceNavIcon: React.FC = () => <ClipboardCheck {...navIconProps} />;

export const SessionsNavIcon: React.FC = () => <CalendarDays {...navIconProps} />;

export const MembersNavIcon: React.FC = () => <Users {...navIconProps} />;

export const BillingNavIcon: React.FC = () => <CircleDollarSign {...navIconProps} />;

export const SettingsNavIcon: React.FC = () => <Settings {...navIconProps} />;

export const LogoutNavIcon: React.FC = () => <LogOut size={16} strokeWidth={NAV_STROKE_WIDTH} />;
